import React, { useState } from "react";
import { Tabs, Tab, Paper, withStyles, Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import UserSettings from "./YourSettings";
import UserAddress from "./AddressInformation";
import { updateURL } from '../sc-utilities';
import UserInformation from "./UserInformation";
import { BackButton, hasAtLeastOnePermission } from '../sc-utilities';
import IndividualLicenses from "./IndividualLicenses";
import * as userActions from '../sc-users/User/store/userActions';

const styles = theme => ({
    root: {
        width: `99.1%`,
        height: 'auto',
        margin: '7px',
        marginBottom: 0,
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    [theme.breakpoints.down("sm")]: {
        padding: 0,
        margin: 0,
        paddingRight: 0
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ paddingRight: 6, paddingLeft: 6, paddingTop: 6 }}>
            {props.children}
        </Typography>
    );
};
const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

function TabPanel(props) {
    const { children, value, index, style, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: '0px', ...style }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}
const ProfileViewTabs = props => {
    const { classes, theme, translations, permissions, user, onLoadUser, activeCustomer } = props;
    const [tabValue, setTabValue] = useState(getTabValue());

    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };

    return (<>
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Tabs value={tabValue} onChange={handleChange} indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="on">
                <Tab label={translations["personal_information"] || "Personal information"} value={0} />
                <Tab label={translations["user_address"] || "User address"} disabled={!hasAtLeastOnePermission(permissions, ['address_create', 'address_load'])} value={1} />
                <Tab label={translations["your_settings"] || "Your settings"} value={2} />
                <Tab label={translations["individual_licenses"] || "Individual licenses"} value={3} />
            </Tabs>
        </Paper>
        <TabContainer style={{ padding: 0 }} dir={theme.direction}>
            <TabPanel index={0} value={tabValue}>
                <UserInformation />
            </TabPanel>  </TabContainer>
        {hasAtLeastOnePermission(permissions, ['address_create', 'address_load']) ? <TabContainer style={{ padding: 0 }} dir={theme.direction}>
            <TabPanel index={1} value={tabValue} style={{ marginTop: '-5px' }}>
                <UserAddress tabValue={tabValue}
                />
            </TabPanel> </TabContainer>
            : null}
        <TabContainer style={{ padding: 0 }} dir={theme.direction}>
            <TabPanel index={2} value={tabValue} style={{ marginTop: '-26px' }} >
                <UserSettings />
            </TabPanel> </TabContainer>
        <TabContainer style={{ padding: 0 }} dir={theme.direction}>
            <TabPanel index={3} value={tabValue} style={{ marginTop: '-15px' }} >
                <IndividualLicenses user={user} onLoadUser={onLoadUser} activeCustomer={activeCustomer} translations={translations} />
            </TabPanel>
        </TabContainer>
    </>
    );
};
const mapStateToProps = state => {
    return {
        user: state?.core?.login?.user || {},
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLoadUser: user => dispatch(userActions.loadUser(user)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(ProfileViewTabs));
